export default {
  myQuizzes: [],
  quiz: {},
};



// WEBPACK FOOTER //
// ./src/app/my-quizzes/store/state.js